import React from 'react'
import { useTranslation } from 'react-i18next';
import DocumentationSidebar from '../component/DocumentationSidebar'
import { useDocImage } from '../hooks/useDocImage';

export default function FormBuilder() {
  const { t } = useTranslation();
  const image001 = useDocImage('form-builder-img', 'image001.png');
  const image002 = useDocImage('form-builder-img', 'image002.png');
  const image003 = useDocImage('form-builder-img', 'image003.jpg');
  const image004 = useDocImage('form-builder-img', 'image004.png');
  const image005 = useDocImage('form-builder-img', 'image005.jpg');
  const image006 = useDocImage('form-builder-img', 'image006.png');
  const image007 = useDocImage('form-builder-img', 'image007.jpg');
  const image008 = useDocImage('form-builder-img', 'image008.png');
  const image009 = useDocImage('form-builder-img', 'image009.png');
  const image010 = useDocImage('form-builder-img', 'image010.png');
  const image011 = useDocImage('form-builder-img', 'image011.png');

  return (
    <>
      <div className='d-flex flex-column main-outer-wrapper'>
        <div className="flex-grow-1 d-flex survey-main-wrapper">
          <DocumentationSidebar />

          {/* Dashboard Content */}
          <div className="flex-grow-1 dashboard-page-outer">
            <div className='dashboard-page-wrap document-page-wrap'>

              <h1 className='mt-0 text-primary'>{t('documentation.formBuilder.title')}</h1>
              <p className='header-para'>
                {t('documentation.formBuilder.intro')}
              </p>

              <div className="card dashboard-card mb-4">
                <div className="card-header d-md-flex justify-content-between align-items-center px-3">
                  {t('documentation.formBuilder.access.title')}
                </div>
                <div className="card-body">

                  <ul>
                    <li>  {t('documentation.formBuilder.access.step1')}
                      <img src={image010} alt={t('documentation.formBuilder.access.imageAlt')} className='img-fluid pb-10 pt-10' />
                    </li>
                    <li>{t('documentation.formBuilder.access.step2')} <br />
                      <img src={image011} alt={t('documentation.formBuilder.access.imageAlt')} className='pb-10' />
                    </li>
                   
                  </ul>

                </div>
              </div>

              <div className="card dashboard-card mb-4">
                <div className="card-header d-md-flex justify-content-between align-items-center px-3">
                  {t('documentation.formBuilder.leadForm.title')}
                </div>
                <div className="card-body">

                  <ul>
                    <li>  {t('documentation.formBuilder.leadForm.breadcrumbDesc')} <br />
                      <img src={image001} alt={t('documentation.formBuilder.leadForm.imageAlt')} className='img-fluid pt-10 pb-10 w-70' />
                    </li>
                    <li>{t('documentation.formBuilder.leadForm.headingDesc')}
                      <img src={image002} alt={t('documentation.formBuilder.leadForm.imageAlt')} className='img-fluid pb-10 w-70' />
                    </li>
                    <li> {t('documentation.formBuilder.leadForm.addFieldDesc')} <br />
                      <img src={image003} alt={t('documentation.formBuilder.leadForm.imageAlt')} className='pt-20 pb-20' />
                    </li>
                    <li> {t('documentation.formBuilder.leadForm.addedFieldDesc')}
                      <img src={image004} alt={t('documentation.formBuilder.leadForm.imageAlt')} className='img-fluid pb-20 pt-20 w-80' />
                    </li>
                  </ul>

                </div>
              </div>

              <div className="card dashboard-card mb-4">
                <div className="card-header d-md-flex justify-content-between align-items-center px-3">
                  {t('documentation.formBuilder.userGuide.title')}
                </div>
                <div className="card-body">

                  <p> <b>{t('documentation.formBuilder.userGuide.step1Title')}</b>   </p>
                  <ul>
                    <li> {t('documentation.formBuilder.userGuide.editIconDesc')} </li>
                    <li>{t('documentation.formBuilder.userGuide.noteDesc')}</li>
                    <img src={image005} alt={t('documentation.formBuilder.userGuide.imageAlt')} className='img-fluid pt-20 pb-20 w-70' />
                  </ul>

                  <p> <b>{t('documentation.formBuilder.userGuide.step2Title')}</b>   </p>
                  <ul>
                    <li> {t('documentation.formBuilder.userGuide.step2Desc')}</li>
                    <img src={image006} alt={t('documentation.formBuilder.userGuide.imageAlt')} className='img-fluid pt-20 pb-20 w-70' />
                  </ul>

                  <p> <b>{t('documentation.formBuilder.userGuide.step4Title')}</b>   </p>
                  <ul>
                    <li> {t('documentation.formBuilder.userGuide.step4Desc')}</li>
                    <img src={image007} alt={t('documentation.formBuilder.userGuide.imageAlt')} className='pb-20 pt-10' />
                  </ul>

                  <p> <b>{t('documentation.formBuilder.userGuide.step5Title')}</b>   </p>
                  <ul>
                    <li> {t('documentation.formBuilder.userGuide.step5Desc')}</li>
                    <img src={image008} alt={t('documentation.formBuilder.userGuide.imageAlt')} className='img-fluid pt-20 pb-20' />
                  </ul>

                  <p> <b>{t('documentation.formBuilder.userGuide.step6Title')}</b>   </p>
                  <ul>
                    <li> {t('documentation.formBuilder.userGuide.step6Desc')}</li>
                    <img src={image009} alt={t('documentation.formBuilder.userGuide.imageAlt')} className='pt-20 pb-10' />
                  </ul>


                </div>
              </div>


            </div>
          </div>

        </div>
      </div>
    </>
  )
}
